const masterImageAnchors: { [key: number]: string } = {
  1: "cover",
  2: "atmosphere",
  3: "monitors",
  4: "seats",
  5: "drinks",
  6: "others",
};

export const masterImageId2Anchor = (id: number): string => {
  return masterImageAnchors[id] ?? "";
};
